const BANNER_LOCALSTORAGE = 'aryaBanner'

export default {
  name: 'banner',
  inject: [
    '$utils'
  ],
  components: {
  },
  props: {
    isVisibleProp: {
      type: Boolean,
      default () { return false }
    }
  },
  watch: {
    isVisibleProp (newisVisible) {
      this.isVisible = newisVisible
    },
    '$route.params' (routeTo) {
      this.handleBannerVisibility()
    }
  },
  mixins: [],
  data () {
    return {
      productName: CONFIG.PRODUCT_NAME,
      callbacks: {},
      isVisible: this.isVisibleProp,
      enableBanner: false,
      releaseDate: '2022-05-31',
      releaseTime: '04:00 UTC',
      approximateHours: '1',
      bannerTimestamp: new Date('May 23, 2022 01:00:00'), // banner dismissed before this time will pop-up again
      learnMoreURL: 'https://support.spinetix.com/wiki/Cloud_Maintenance_May_2022'
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('banner-change', { action, payload: { data } })
      }
    },
    handleCloseBanner () {
      this.isVisible = false

      // Update localStorage acceptance date
      const localStorageData = this.getDataFromLocalstorage()
      localStorageData.downtimeNoticeAcceptanceDate = Date.now()
      localStorage.setItem(BANNER_LOCALSTORAGE, JSON.stringify(localStorageData))
      this.adjustCommonElements(true)

      // Run eventOnClose callback
      if (typeof this.callbacks.eventOnClose === 'function') {
        this.callbacks.eventOnClose()
      }
    },
    getDataFromLocalstorage () {
      const data = localStorage.getItem(BANNER_LOCALSTORAGE)

      if (data !== null && data !== '') return JSON.parse(data)

      return null
    },
    setAryaBannerInLocalStorage () {
      const data = {
        downtimeNoticeAcceptanceDate: null
      }

      localStorage.setItem(BANNER_LOCALSTORAGE, JSON.stringify(data))
    },
    handleBannerVisibility () {
      this.isVisible = false
      const userAcceptanceDate = (this.getDataFromLocalstorage() && this.getDataFromLocalstorage().downtimeNoticeAcceptanceDate) ? this.getDataFromLocalstorage().downtimeNoticeAcceptanceDate : null

      // User acceptance test
      if (!userAcceptanceDate) {
        this.setAryaBannerInLocalStorage()
        this.isVisible = true
      } else if (new Date(userAcceptanceDate) < new Date(this.bannerTimestamp)) { // If acceptance date is before the banner time
        this.isVisible = true
      }

      // Force not to show banner if mark as disabled
      if (!this.enableBanner) this.isVisible = false

      this.adjustCommonElements(true)
    },
    adjustCommonElements (setTimeout) {
      const adjustStyleActions = () => {
        const bannerHeight = this.isVisible ? (this.$utils.is1280View() ? 54 : 64) : 0

        // Adjust navigation element
        const navigationEl = $('#navigation')
        navigationEl.css({
          top: `${bannerHeight}px`
        })
      }

      if (setTimeout) {
        window.setTimeout(() => { adjustStyleActions() }, 1)
      } else {
        adjustStyleActions()
      }
    }
  },
  mounted () {
    this.handleBannerVisibility()
    $(window).resize(() => { this.adjustCommonElements() })
  }
}
